module.exports = __webpack_public_path__ + "5a3ce23264caa16eee9006f839dd1347.svg";